module.exports = __webpack_public_path__ + "static/media/logo-full-white.96fb55cc.svg";